var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index_content"},[_c('div',{staticClass:"i-font",class:[_vm.color[_vm.cKey],_vm.dataDetial.icon]}),_vm._v(" "),_c('div',{staticClass:"i-des",attrs:{"title":_vm.dataDetial.headline}},[_vm._v(_vm._s(_vm.dataDetial.subheading))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6aa31e2f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/IndexItem.vue
// module id = null
// module chunks = 